/**
 * Landing Page
 * ZO Bull Algo Trading Platform
 */
import LandingHero from '../components/LandingHero'
import LandingFeatures from '../components/LandingFeatures'
import LandingBrokers from '../components/LandingBrokers'
import LandingHowItWorks from '../components/LandingHowItWorks'
import LandingAISection from '../components/LandingAISection'
import LandingPricing from '../components/LandingPricing'
import LandingFooter from '../components/LandingFooter'
import './Landing.css'

export default function Landing() {
  return (
    <div className="landing-page">
      <LandingHero />
      <LandingFeatures />
      <LandingBrokers />
      <LandingHowItWorks />
      <LandingAISection />
      <LandingPricing />
      <LandingFooter />
    </div>
  )
}
